import { initialPromoState, PromoActionTypes } from '../types';
import createAsyncMapReducer from '~lib/shared/redux/reducers/async-map-reducer';
const UpdatePromoReducer = createAsyncMapReducer(PromoActionTypes.UPDATE_PROMO, initialPromoState.updatePromo);
export default UpdatePromoReducer;
